/* UBE Club new design: interactions wired to the Shopify cart.
   Based on the approved high-fidelity design.js; the simulated bag is replaced
   by /cart.js, /cart/add.js and /cart/change.js. */
(() => {
const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
const UBE = window.UBE || {};
const reduced = matchMedia('(prefers-reduced-motion:reduce)');
let quantity = 1, paused = false, cart = null;

const formatAed = fils => {
  const value = fils / 100;
  return 'AED ' + (Number.isInteger(value) ? value : value.toFixed(2));
};

/* ---------- quantity and price ---------- */
function update() {
  $$('[data-qty]').forEach(e => e.textContent = quantity);
  $$('[data-price]').forEach(e => e.textContent = formatAed(UBE.unitPrice * quantity));
  $$('[data-chances]').forEach(e => e.textContent = quantity === 1 ? '1 chocolate · 1 Golden Ticket chance' : `${quantity} chocolates · ${quantity} chances`);
  $$('[data-sticky-qty]').forEach(e => e.textContent = `${quantity} chocolate${quantity === 1 ? '' : 's'}`);
}
$('[data-minus]')?.addEventListener('click', () => { quantity = Math.max(1, quantity - 1); update(); });
$('[data-plus]')?.addEventListener('click', () => { quantity = Math.min(20, quantity + 1); update(); });

/* ---------- cart ---------- */
const lineForProduct = () => cart?.items.find(i => i.variant_id === UBE.variantId);

async function refreshCart() {
  try {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    cart = await res.json();
  } catch (e) { cart = cart || { item_count: 0, total_price: 0, items: [] }; }
  renderBag();
  return cart;
}

function renderBag() {
  const count = cart?.item_count || 0;
  const line = lineForProduct();
  $$('[data-bag-count],[data-dialog-count]').forEach(e => e.textContent = count);
  $$('[data-cart-qty]').forEach(e => e.textContent = line ? line.quantity : 0);
  const subtotal = $('[data-subtotal]');
  if (subtotal) subtotal.textContent = formatAed(cart?.total_price || 0);
  const item = $('.bag-item');
  if (item) item.hidden = !line;
  let empty = $('[data-empty-bag]');
  if (!empty && item) {
    empty = document.createElement('p');
    empty.dataset.emptyBag = '';
    empty.innerHTML = `Your bag is empty. <a href="${UBE.productUrl}">SHOP UBE CLOUD · ${formatAed(UBE.unitPrice)}</a>`;
    item.before(empty);
  }
  if (empty) empty.hidden = count > 0;
  $$('[data-cart-filled]').forEach(e => e.hidden = !count);
}

function openBag() {
  const dialog = $('#bag');
  if (dialog && !dialog.open) dialog.showModal();
}

function showBagError(message) {
  let note = $('[data-bag-error]');
  if (!note) {
    note = document.createElement('p');
    note.dataset.bagError = '';
    note.className = 'checkout-note';
    note.setAttribute('role', 'status');
    $('#bag .dialog-heading')?.after(note);
  }
  note.textContent = message;
  note.hidden = false;
}

async function addToCart(qty) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: UBE.variantId, quantity: qty }] })
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.description || data.message || 'Could not add to bag.');
  }
  return refreshCart();
}

async function changeLine(newQty) {
  const line = lineForProduct();
  if (!line) return;
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: line.key, quantity: newQty })
  });
  if (res.ok) { cart = await res.json(); renderBag(); }
}

$$('[data-add]').forEach(button => button.addEventListener('click', async () => {
  if (button.disabled) return;
  if (UBE.available === false) { showBagError('Ube Cloud is sold out right now.'); openBag(); return; }
  const original = button.innerHTML, label = button.querySelector('span');
  button.disabled = true;
  try {
    await addToCart(quantity);
    const done = `ADDED <img src="${UBE.checkmark}" alt="">`;
    if (label) label.innerHTML = done; else button.innerHTML = done;
    $('[data-bag-error]')?.setAttribute('hidden', '');
    openBag();
    setTimeout(() => { button.innerHTML = original; button.disabled = false; update(); }, 2000);
  } catch (err) {
    button.innerHTML = original; button.disabled = false;
    showBagError(err.message); openBag();
  }
}));

const onCartPage = document.body.classList.contains('template-cart');
$('[data-bag]')?.addEventListener('click', async () => {
  if (onCartPage) { window.scrollTo({ top: 0, behavior: reduced.matches ? 'instant' : 'smooth' }); return; }
  await refreshCart(); openBag();
});

/* Cart page: +/- steppers update the native cart form. */
const cartForm = $('#ube-cart-form');
if (cartForm) {
  let submitTimer = 0;
  $$('[data-ube-qty]').forEach(box => {
    const input = box.querySelector('input');
    box.querySelectorAll('[data-step]').forEach(btn => btn.addEventListener('click', () => {
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(btn.dataset.step));
      clearTimeout(submitTimer);
      submitTimer = setTimeout(() => cartForm.submit(), 450);
    }));
    input.addEventListener('change', () => { clearTimeout(submitTimer); submitTimer = setTimeout(() => cartForm.submit(), 300); });
  });
}
$$('[data-close-bag]').forEach(e => e.addEventListener('click', () => $('#bag').close()));
$$('[data-checkout]').forEach(e => e.addEventListener('click', () => { window.location.href = '/checkout'; }));
$('[data-buy-now]')?.addEventListener('click', () => { window.location.href = `/cart/${UBE.variantId}:${quantity}`; });

const cartItem = $('.bag-item>div');
if (cartItem) {
  const control = document.createElement('div');
  control.className = 'bag-item-quantity';
  control.innerHTML = '<button data-cart-minus aria-label="Remove one chocolate">−</button><span data-cart-qty></span><button data-cart-plus aria-label="Add one chocolate">+</button>';
  cartItem.append(control);
  $('[data-cart-minus]').addEventListener('click', () => { const l = lineForProduct(); if (l) changeLine(l.quantity - 1); });
  $('[data-cart-plus]').addEventListener('click', () => { const l = lineForProduct(); if (l) changeLine(l.quantity + 1); });
}
if (UBE.available === false) $$('[data-add]').forEach(b => { b.disabled = true; const s = b.querySelector('span'); if (s) s.textContent = 'SOLD OUT'; else b.textContent = 'SOLD OUT'; });
update();
refreshCart();

/* ---------- menu ---------- */
const menu = $('[data-menu]');
const closeMenu = () => { $('header nav')?.classList.remove('is-open'); menu?.setAttribute('aria-expanded', 'false'); };
menu?.addEventListener('click', () => { const open = $('header nav').classList.toggle('is-open'); menu.setAttribute('aria-expanded', String(open)); });
$$('header nav a').forEach(a => a.addEventListener('click', closeMenu));
document.addEventListener('click', e => { if (menu?.getAttribute('aria-expanded') === 'true' && !e.target.closest('header nav, [data-menu]')) closeMenu(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') { closeMenu(); menu.focus(); } });

/* ---------- gallery ---------- */
const gallery = [['broken', 'Broken cross-section'], ['whole', 'Whole chocolate'], ['hand', 'Held in hand'], ['box', 'Open gift box']];
const track = $('.gallery-track');
let activeImage = 0, dragStart = 0, dragDistance = 0;
function setImage(i) {
  activeImage = i;
  $$('[data-image]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.image) === i)));
  $$('[data-slide]').forEach((slide, n) => { slide.tabIndex = n === i ? 0 : -1; slide.setAttribute('aria-hidden', String(n !== i)); });
  track?.setAttribute('aria-label', `Ube Cloud product images: ${gallery[i][1]}`);
}
function showImage(i) {
  if (!track) return;
  i = (i + gallery.length) % gallery.length;
  track.scrollTo({ left: i * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
  setImage(i);
}
if (track) {
  setImage(0);
  track.addEventListener('scrollend', () => setImage(Math.max(0, Math.min(3, Math.round(track.scrollLeft / track.clientWidth)))), { passive: true });
  track.addEventListener('pointerdown', e => { dragStart = e.clientX; dragDistance = 0; }, { passive: true });
  track.addEventListener('pointermove', e => { if (e.buttons || e.pointerType === 'touch') dragDistance = Math.max(dragDistance, Math.abs(e.clientX - dragStart)); }, { passive: true });
  track.addEventListener('touchstart', e => { dragStart = e.touches[0].clientX; dragDistance = 0; }, { passive: true });
  track.addEventListener('touchmove', e => { dragDistance = Math.max(dragDistance, Math.abs(e.touches[0].clientX - dragStart)); }, { passive: true });
}
$$('[data-image]').forEach(e => e.addEventListener('click', () => showImage(Number(e.dataset.image))));
$('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeImage - 1));
$('[data-gallery-next]')?.addEventListener('click', () => showImage(activeImage + 1));
$$('[data-slide]').forEach(e => e.addEventListener('click', () => {
  if (dragDistance > 15) return;
  const img = e.querySelector('.product-cutout'), large = $('.enlarged-product');
  if (!img || !large) return;
  large.src = img.currentSrc || img.src; large.removeAttribute('srcset'); large.alt = img.alt;
  $('#image-dialog').showModal();
}));
$('[data-close-image]')?.addEventListener('click', () => $('#image-dialog').close());

/* ---------- sticky purchase bar ---------- */
const sticky = $('.sticky-buy'), primary = $('.primary-purchase');
if (sticky && primary) {
  const sync = () => { sticky.hidden = primary.getBoundingClientRect().bottom > 0 || $$('dialog').some(d => d.open); };
  new IntersectionObserver(sync).observe(primary);
  addEventListener('scroll', sync, { passive: true });
  addEventListener('resize', sync);
  const mo = new MutationObserver(sync);
  $$('dialog').forEach(d => mo.observe(d, { attributes: true, attributeFilter: ['open'] }));
  sync();
}

/* ---------- motion, film ---------- */
const heroVideo = $('.hero-video'), filmDialog = $('#film-dialog'), film = filmDialog?.querySelector('video');
const isVideo = el => el && el.tagName === 'VIDEO';
const desktop = matchMedia('(min-width:701px)');
function syncMotion() {
  document.body.classList.toggle('motion-paused', paused || reduced.matches);
  if (isVideo(heroVideo)) { if (paused || reduced.matches || document.hidden || !desktop.matches) heroVideo.pause(); else heroVideo.play().catch(() => {}); }
  if (reduced.matches) $$('.will-reveal').forEach(e => e.classList.add('is-visible'));
}
syncMotion();
reduced.addEventListener('change', syncMotion);
desktop.addEventListener('change', syncMotion);
document.addEventListener('visibilitychange', syncMotion);
$('[data-motion-toggle]')?.addEventListener('click', e => { paused = !paused; e.currentTarget.textContent = paused ? 'Resume motion' : 'Pause motion'; syncMotion(); });
$('[data-watch-film]')?.addEventListener('click', () => { if (!filmDialog) return; filmDialog.showModal(); if (isVideo(heroVideo)) heroVideo.pause(); film?.play().catch(() => {}); });
$('[data-close-film]')?.addEventListener('click', () => filmDialog?.close());
filmDialog?.addEventListener('close', () => { film?.pause(); syncMotion(); });

/* Reveal on scroll. Content is never left hidden: anchors, hash changes and a
   short fallback reveal everything that has not animated in yet. */
if (!reduced.matches) {
  const reveals = $$('[data-reveal]');
  reveals.forEach((e, i) => { if (e.getBoundingClientRect().top > innerHeight) { e.classList.add('will-reveal'); e.style.setProperty('--reveal-delay', `${i % 3 * 60}ms`); } });
  const reveal = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => { if (isIntersecting) { target.classList.add('is-visible'); reveal.unobserve(target); } }), { rootMargin: '0px 0px 15% 0px', threshold: 0 });
  reveals.forEach(e => reveal.observe(e));
  const revealAll = () => $$('.will-reveal:not(.is-visible)').forEach(e => e.classList.add('is-visible'));
  addEventListener('hashchange', revealAll);
  $$('a[href*="#"]').forEach(a => a.addEventListener('click', revealAll));
  $$('.collection-track .will-reveal').forEach(e => e.classList.add('is-visible'));
  setTimeout(() => {
    let lastY = scrollY;
    let maxY = scrollY;
    // Reveal everything above the furthest point reached, so a fast flick or a bounce back never skips a section.
    const inView = () => { maxY = Math.max(maxY, scrollY); $$('.will-reveal:not(.is-visible)').forEach(e => { if (e.getBoundingClientRect().top + scrollY < maxY + innerHeight) e.classList.add('is-visible'); }); };
    const fastScroll = () => { if (Math.abs(scrollY - lastY) > innerHeight * 1.5) revealAll(); lastY = scrollY; inView(); };
    addEventListener('scroll', fastScroll, { passive: true });
  }, 500);
}

/* ---------- parallax and tilt ---------- */
let scrollFrame = 0;
const parallax = $$('[data-parallax]');
function drawParallax() {
  scrollFrame = 0;
  if (reduced.matches || paused) return;
  parallax.forEach(e => { const r = e.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) e.style.transform = `translateY(${Math.max(-16, Math.min(16, (innerHeight / 2 - r.top) * Number(e.dataset.parallax)))}px)`; });
}
addEventListener('scroll', () => { if (!scrollFrame) scrollFrame = requestAnimationFrame(drawParallax); }, { passive: true });
$$('.prize-tilt').forEach(e => {
  e.addEventListener('pointermove', p => {
    if (reduced.matches || paused) return;
    const r = e.getBoundingClientRect();
    e.querySelector('img').style.transform = `rotateY(${(p.clientX - r.left - r.width / 2) / r.width * 12}deg) rotateX(${-(p.clientY - r.top - r.height / 2) / r.height * 8}deg)`;
  });
  e.addEventListener('pointerleave', () => { e.querySelector('img').style.transform = ''; });
});
})();
